import React, { useEffect, useState } from "react";
import { Card, Flex, Text, BrandButton, Banner } from "@jsq/ds/core";
import classNames from "classnames";
import styles from "./styles.scss";
import { providersMap } from "./constants";
import { type SingleSignOnCardProps } from "./types";

const SingleSignOnCard = ({
  arena,
  isContained,
  provider,
  providerName,
  onSignIn,
}: SingleSignOnCardProps) => {
  const [ssoError, setSsoError] = useState<string | undefined>(undefined);

  // When SSO auth fails in JSQ, we redirect to login and display an error message
  const searchParams = new URLSearchParams(location.search);
  useEffect(() => {
    if (searchParams.get("ssoError") === "unknown_user") {
      // Unknown user error occurs when SSO succeeds for the IDP, but fails in JSQ due to the user not being found. To
      // resolve, the customer needs to create a staff user with the same email.
      setSsoError("User not found. Speak with your administrator to provision an account.");
    } else if (searchParams.get("ssoError") === "unknown_error") {
      // Failure due to errors in the OneLogin_Saml2_Auth request. Might be a transient error or require investigation
      setSsoError(
        "Login failed due to an unexpected error. If this issue persists, please contact support.",
      );
    }
  }, []);

  const ssoProvider = providersMap[provider];
  if (!ssoProvider) {
    return null;
  }
  const content = (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      className={classNames(isContained && styles.SingleSignOnCard__contained)}
    >
      {arena && (
        <Text variant="h2" marginBottom="xl" align="center">
          Sign in to {arena}
        </Text>
      )}
      {ssoError && (
        <Banner className="stacked-lg" variant="danger" title="Error" description={ssoError} />
      )}
      <BrandButton brand={ssoProvider.brand} isFullWidth onClick={onSignIn}>
        {`Sign in with ${providerName}`}
      </BrandButton>
    </Flex>
  );

  return isContained ? content : <Card className={styles.SingleSignOnCard}>{content}</Card>;
};

export { SingleSignOnCard };
